import React from 'react'
import Button from '../../../components/shared/button/Button'

const HeroSection = () => {
    return (
        <div className="max-lg:flex-col relative min-h-[1000px] heroBack flex items-center justify-between py-[64px] pb-[96px] max-lg:gap-[32px] w-full max-w-[1600px]">
            <div className="flex flex-col max-lg:items-center items-start gap-[48px] max-sm:pl-[0px] max-2xl:pl-[5.8vw] max-sm:gap-[24px]">
                <div className="flex flex-col items-start gap-[24px] max-lg:items-center max-sm:gap-[16px]">

                    <div className="max-sm:hidden flex items-center justify-center rounded-full p-[4px] bg-[#F5F6FF] border-[1px] border-[#D7EBFE] gap-[10px] pr-[10px] group">
                        <span className='text-[14px] text-[#2B3DDE] px-[10px] py-[2px] rounded-full border-[1px] border-[#E9D7FE]'>
                            We’re Launching our mobile app!
                        </span>
                        <div className="flex items-center gap-[4px] transition-all group-hover:gap-[10px]">
                            <span className='text-[14px] text-[#2B3DDE]'>
                                Certified DJ’s app coming soon
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className='transition-all'>
                                <path d="M3.33334 8.00004H12.6667M12.6667 8.00004L8 3.33337M12.6667 8.00004L8 12.6667" stroke="#2B3DDE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <h1 className='font-bold text-[#101828] max-w-[584px] max-2xl:text-[48px] max-xl:text-[42px] max-lg:text-center text-[60px] md:text-[48px] max-sm:text-[28px]'>
                        Streamline Your DJ Business. Connect With Clients Effortlessly.  Manage Your bookings, and Client Interactions With Ease!
                    </h1>

                    <p className='text-[20px] text-[#475467] max-w-[480px] max-lg:text-center max-sm:text-[16px]'>
                        Unleash Your Potential: Seamless Bookings, Great community & More!
                    </p>

                </div>
                <Button children={'Join Waiting List'} />
            </div>
            <img
                src="/images/heroImage.png"
                alt=""
                className='heroImage max-w-[760px] max-2xl:max-w-[660px] max-xl:max-w-[560px] max-sm:max-w-full'
            />
        </div>
    )
}

export default HeroSection;